<template>
  <div class="schedule-breadcrumb">
    <div
      v-if="current_schedule && current_step > 0"
      class="schedule-breadcrumb__content"
    >
      <div class="schedule-breadcrumb__icon">
        <i class="material-icons d-block">edit</i>
      </div>
      <div v-if="current_schedule.service && current_step > 1" class="ml-3">
        <p class="schedule-breadcrumb__text text mb-0">Estás agendando</p>
        <h3 class="title text-primary weight-bold">
          <router-link :to="{ name: 'schedule-service' }">{{
            current_schedule.service.name
          }}</router-link>
        </h3>
      </div>
      <div v-if="current_schedule.office && current_step > 2" class="ml-5">
        <p class="schedule-breadcrumb__text text mb-0">Lugar</p>
        <h3 class="title text-primary weight-bold">
          <router-link
            :to="{ name: 'schedule-place', service: current_schedule.service }"
            >{{ current_schedule.office.office.name }}</router-link
          >
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ScheduleBreadcrumb',
  computed: {
    ...mapState(['current_schedule', 'current_step']),
  },
};
</script>

<style></style>
